<template>
    <div>
        <!-- UneCont -->
        <div class="modal fade" id="uneContVincModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">UneCont / Vínculo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row mb-2"> 
                            <div class="col col-md-6">
                                <az-periodo v-model="filtro" :sync="true" @sync="load(false)" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    icon="fa-solid fa-magnifying-glass fa-fw"
                                    placeholder="Pesquisar..."
                                    v-model="filtro.pesquisa" />
                            </div>
                        </div>

                        <az-empty-state
                            v-if="!exibicao || exibicao.length == 0"
                            icon="fa-solid fa-file-invoice-dollar"
                            title="Nenhuma NF identificada." />

                        <table class="table table-hover table-sm mt-3 small" v-else-if="exibicao && exibicao.length > 0">
                            <thead>
                                <tr>
                                    <th>Num</th>
                                    <th>NF</th>
                                    <th>Emissão</th>
                                    <th>Descrição</th>
                                    <th class="text-right">Valor</th>
                                    <th class="text-right">Líquido</th>
                                    <th class="text-right">Identificado</th>
                                    <th class="text-right">Saldo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, idx) in exibicao">
                                    <tr :key="idx" v-if="true">
                                        <td>{{ item.st_id_externo }}</td>
                                        <td>
                                            <a href="#" @click.prevent="selecionar(item)" class="card-link">{{ item.st_numero_nf }}</a>
                                        </td>
                                        <td>{{ $util.getFormatDate(item.dt_emissao) }}</td>
                                        <td>{{ item.st_descricao }}</td>
                                        <td class="text-right">{{ $util.formatMoeda(item.dc_valor_bruto) }}</td>
                                        <td class="text-right">{{ $util.formatMoeda(item.dc_valor_liquido) }}</td>
                                        <td class="text-right">
                                            <a v-if="item.valor_identificado > 0" data-toggle="collapse" :href="'#nf_externa_' + item.id_nota_fiscal_externa">
                                                {{ $util.formatMoeda(item.valor_identificado) }}
                                            </a>
                                        </td>
                                        <td class="text-right">{{ $util.formatMoeda(item.saldo) }}</td>
                                    </tr>
                                    <tr :key="'l' + idx" class="collapse" :id="'nf_externa_' + item.id_nota_fiscal_externa">
                                        <td></td>
                                        <td colspan="7">
                                            <ul class="list-group">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(lanc, ilx) in item.lancamentos" :key="ilx">
                                                    <div>#{{ lanc.id_lancamento }}</div>
                                                    <div>{{ $util.formatMoeda(lanc.liquido) }}</div>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <pre class="alert alert-info" v-if="false">{{ lista }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as moment from "moment";
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            dados: null, 
            lista: [], 
            filtro: { 
                id_unidade_operacao: this.$store.state.user.id_unidade_operacao || "", 
                num_evento: "",
                periodo: '', 
                inicio: "", 
                fim: "", 
                pesquisa: "", 
            },
        }
    },

    components: { 
        AzInput, 
        AzPeriodo, 
        AzEmptyState,  
    },

    computed: { 
        exibicao: function () { 
            if ( !this.lista ) 
                return [];

            let reg = this.$util.getregex(this.filtro.pesquisa);
            return this.lista.filter(item => !this.filtro.pesquisa || reg.test(JSON.stringify(item)));
        }
    },

    methods: { 
        abrir(lancamento) { 
            this.dados = lancamento; 

            this.filtro.inicio = moment(lancamento.dt_emissao).subtract(5, "days").format('YYYY-MM-DD');
            this.filtro.fim = moment(lancamento.dt_emissao).add(5, "days").format('YYYY-MM-DD');

            $('#uneContVincModal').modal('show');

            this.load();
        },

        load() { 

            this.$util.load(this, { 
                service: 'nota_fiscal_externas',
                func: 'index', 
                redir_api: true, 
                parms: { 
                    ...this.filtro,
                    vinc: true, 
                    id_unidade_operacao: this.dados.id_unidade_operacao, 
                    id_fornecedor: this.dados.fornecedor ? this.dados.fornecedor.id_fornecedor : null,
                },
                loadTo: res => { 
                    this.lista = res;
                }
            });
            
        },

        selecionar (nfex) { 
            this.$emit('selecionar', nfex);
            $('#uneContVincModal').modal('hide');
        }

    }
    
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
